<app-topbar></app-topbar>

<kendo-drawer-container>
  <kendo-drawer style="position: sticky"
                [autoCollapse]="false"
                [items]="links"
                #drawer
                mode="push"
                [mini]="true"
                [(expanded)]="expanded"
                [isItemExpanded]="isItemExpanded"
                (select)="onSelect($event)">

    <ng-template kendoDrawerHeaderTemplate>
      <div class="kendo-drawer-header" (click)="onMenuClick()">
        <span class="k-icon k-i-menu menu-icon kendo-primary-100"></span>
      </div>
    </ng-template>

    <ng-template kendoDrawerItemTemplate let-level="level" let-item>
      <div  routerLinkActive="k-selected"
            class="k-drawer-link"
            [routerLink]="item.path ? item.path : undefined">
        <span class="k-icon {{item.icon}}"></span>
        <div *ngIf="expanded">{{ "NAVIGATION." + item.text | uppercase | translate }}</div>
      </div>
    </ng-template>
  </kendo-drawer>

  <kendo-drawer-content>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </kendo-drawer-content>
</kendo-drawer-container>
